import { L, vocabulary } from '../define.js';
export const BROADCAST_VOCABULARIES = [
    vocabulary('broadcast.audience', '@vello/broadcast BANNER_AUDIENCES', {
        RIDER: L('Passageiros', 'Riders', 'Pasajeros', 'Passeggeri'),
        DRIVER: L('Motoristas', 'Drivers', 'Conductores', 'Autisti'),
    }),
    vocabulary('broadcast.channel', '@vello/broadcast BROADCAST_CHANNELS', {
        IN_APP: L('No aplicativo', 'In the app', 'En la app', 'Nell’app'),
        SMS: L('SMS (mensagem de texto)', 'SMS (text message)', 'SMS (mensaje de texto)', 'SMS (messaggio di testo)'),
        WHATSAPP: L('WhatsApp', 'WhatsApp', 'WhatsApp', 'WhatsApp'),
    }),
    vocabulary('broadcast.status', '@vello/broadcast BROADCAST_STATUSES', {
        QUEUED: L('Na fila', 'Queued', 'En cola', 'In coda'),
        RUNNING: L('Enviando', 'Sending', 'Enviando', 'In invio'),
        DONE: L('Concluído', 'Done', 'Completado', 'Completato'),
        CANCELLED: L('Cancelado', 'Cancelled', 'Cancelado', 'Annullato'),
    }),
    vocabulary('broadcast.ride_history_filter', '@vello/broadcast RIDE_HISTORY_FILTERS', {
        ANY: L('Com ou sem corridas', 'With or without rides', 'Con o sin viajes', 'Con o senza corse'),
        WITH_RIDES: L('Com corridas', 'With rides', 'Con viajes', 'Con corse'),
        WITHOUT_RIDES: L('Sem corridas', 'Without rides', 'Sin viajes', 'Senza corse'),
    }),
    vocabulary('broadcast.scope_kind', '@vello/broadcast BANNER_SCOPE_KINDS', {
        PLATFORM: L('Plataforma inteira', 'Whole platform', 'Toda la plataforma', 'Intera piattaforma'),
        COUNTRY: L('País', 'Country', 'País', 'Paese'),
        REGION: L('Região', 'Region', 'Región', 'Regione'),
        MARKET: L('Mercado', 'Market', 'Mercado', 'Mercato'),
    }),
    vocabulary('broadcast.reason', '@vello/broadcast BROADCAST_REASON_CODES', {
        BROADCAST_DELIVERED: L('Entregue', 'Delivered', 'Entregado', 'Consegnato'),
        BROADCAST_QUIET_HOURS_DEFERRED: L('Adiado por horário de silêncio', 'Deferred for quiet hours', 'Aplazado por horario de silencio', 'Rinviato per fascia di silenzio'),
        BROADCAST_NO_MARKETING_CONSENT: L('Sem consentimento para mensagens de marketing', 'No consent for marketing messages', 'Sin consentimiento para mensajes de marketing', 'Nessun consenso ai messaggi di marketing'),
        BROADCAST_NO_ADDRESS: L('Sem contato cadastrado', 'No contact on file', 'Sin contacto registrado', 'Nessun recapito registrato'),
        BROADCAST_ACCOUNT_NOT_ACTIVE: L('Conta inativa', 'Account not active', 'Cuenta inactiva', 'Account non attivo'),
        BROADCAST_NO_TEMPLATE: L('Sem modelo de mensagem aprovado', 'No approved message template', 'Sin plantilla de mensaje aprobada', 'Nessun modello di messaggio approvato'),
        BROADCAST_PROVIDER_FAILED: L('O provedor falhou ao enviar', 'The provider failed to send', 'El proveedor falló al enviar', 'Il provider non è riuscito a inviare'),
        BROADCAST_CAMPAIGN_CANCELLED: L('Envio cancelado', 'Broadcast cancelled', 'Envío cancelado', 'Invio annullato'),
        BROADCAST_CLAIM_ABANDONED: L('Envio interrompido', 'Sending interrupted', 'Envío interrumpido', 'Invio interrotto'),
        BROADCAST_AUDIENCE_CAPPED: L('Limite de público atingido', 'Audience limit reached', 'Límite de público alcanzado', 'Limite di pubblico raggiunto'),
    }),
    vocabulary('broadcast.recipient_status', '@vello/broadcast RECIPIENT_STATUSES', {
        PENDING: L('Aguardando envio', 'Waiting to send', 'Esperando envío', 'In attesa di invio'),
        CLAIMED: L('Em envio', 'Being sent', 'En envío', 'In invio'),
        SENT: L('Enviado', 'Sent', 'Enviado', 'Inviato'),
        SKIPPED: L('Ignorado', 'Skipped', 'Omitido', 'Saltato'),
        FAILED: L('Falhou', 'Failed', 'Fallido', 'Non riuscito'),
    }),
];
//# sourceMappingURL=broadcast.js.map